const colorConverter = () => {
    const colorChecks = document.querySelectorAll('._js-colorcheck') as NodeListOf<HTMLElement>;
    if (colorChecks && colorChecks.length > 0) {
        colorChecks.forEach(item => {
            const myCurrentBackground = item.style.backgroundColor;
            const parts = myCurrentBackground.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            
            if (!parts) return;
            let r = Number(parts[1]);
            let g = Number(parts[2]);
            let b = Number(parts[3]);

            r /= 255;
            g /= 255;
            b /= 255;

            const max = Math.max(r, g, b), min = Math.min(r, g, b);
            let h, s, l = (max + min) / 2;

            if (max === min) {
                h = s = 0; // achromatic
            } else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

                switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
                }
            }
            //var h360 = h * 360;
            //var sPers = s * 100;
            const lightness = l * 100;

            item.style.color = lightness > 50 ? 'black' : 'white';
        });
    }
};

export const init = () => {
    colorConverter();
};
